import { ProductionTimeDTO } from '@/api/dto/ProductionTimeDTO';
import { ProductionTime } from '@/models/entities/ProductionTime';
import { CrudModule, IModuleState } from './CrudModule';
import { EntityType } from '@/store/entityModules/types';
import { SearchQueryFilters } from '@/models/filters/SearchQueryFilters';
import { GetterTree } from 'vuex';

class ProductionTimeModule extends CrudModule<ProductionTime, ProductionTimeDTO> {
  state: IModuleState<ProductionTime, ProductionTimeDTO> = {
    ...this.state,

    entityType: EntityType.PRODUCTION_TIME,
    queryFilters: new SearchQueryFilters({}),
  };

  getters: GetterTree<IModuleState<ProductionTime, ProductionTimeDTO>, any> = {
    ...this.getters,

    getItem: state => (id: number) => {
      const item = state.items.find((i: ProductionTime) => i.id === id);
      return item || null;
    },
  };
}

const productionTimesModule = new ProductionTimeModule();
export default productionTimesModule;
